import React from 'react';

const underlineRegexGlobal = /\|.*?\|/g; // matches |desired underline text|
const underlineCaptureRegex = /\|(.*?)\|/; // captures |desired underline text|
const outlineRegexGlobal = /\*.*?\*/g; // matches *desired outline text*
const outlineCaptureRegex = /\*(.*?)\*/; // captures *desired outline text*
const awardsTitleRegexGlobal = /\^.*?\^/g; // matches ^desired Awards 2021 title text^
const awardsTitleCaptureRegex = /\^(.*?)\^/; // captures ^desired Awards 2021 title text^
const awardsItalicRegexGlobal = /\$.*?\$/g; // matches // &desired Awards 2021 italicized title text&
const awardsItalicCaptureRegex = /\$(.*?)\$/; // captures // &desired Awards 2021 italicized title text&
const breakRegexGlobal = /:br:/g; // matches :linebreak:
const breakCaptureRegex = /:(br):/; // captures :linebreak:

const SPLIT_CHAR = '%%&&';

const generateStyledOutput = () => (potentialStyledOutput, index) => {
  const underlineMatchResult = potentialStyledOutput.match(
    underlineCaptureRegex
  ); // yields |desired underline text|
  const outlineMatchResult = potentialStyledOutput.match(outlineCaptureRegex); // yields *desired text in outline font*
  const awardsTitleMatchResult = potentialStyledOutput.match(
    awardsTitleCaptureRegex
  ); // yields ^desired Awards 2021 title text^
  const awardsItalicMatchResult = potentialStyledOutput.match(
    awardsItalicCaptureRegex
  ); // yields &desired Awards 2021 italicized title text&
  const breakMatchResult = potentialStyledOutput.match(breakCaptureRegex); // yields :linebreak:

  if (underlineMatchResult) {
    const copy = underlineMatchResult[1];

    return (
      <span className="underlined__content" key={`underline-${index}`}>
        {copy}
      </span>
    );
  }

  if (outlineMatchResult) {
    const copy = outlineMatchResult[1];

    return (
      <span className="outlined__content" key={`outline-${index}`}>
        {copy}
      </span>
    );
  }

  if (awardsTitleMatchResult) {
    const copy = awardsTitleMatchResult[1];

    return (
      <span className="awards-title__2021" key={`awards-title-2021-${index}`}>
        {copy}
      </span>
    );
  }

  if (awardsItalicMatchResult) {
    const copy = awardsItalicMatchResult[1];

    return (
      <span className="awards-italic__2021" key={`awards-italic-2021-${index}`}>
        {copy}
      </span>
    );
  }

  if (breakMatchResult) {
    return <br />;
  }

  // content is not in styled format!
  return potentialStyledOutput;
};

export default (content) => {
  if (typeof content === 'string') {
    // Wrap all styled output in a split character
    const bookmarkedString = content
      .replace(
        underlineRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        outlineRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        awardsTitleRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        awardsItalicRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        breakRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      );
    // Split on split char and map everything you can to styled output
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateStyledOutput());
    return result;
  }

  // not parsable
  return content;
};
